import React, { useState, useEffect, useRef } from 'react';
import ReactECharts from 'echarts-for-react';
import { GetIncidentsStadisticsService } from '../../Services/incidentService';
import FormCard from '../common/formCard';
import { Button, Col } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { formatFromDatePicker, formatToSpanishTimeZone } from '../../utils/formatDate';
import { FaRegImage } from 'react-icons/fa6';


export const CaseMetrics = ({ reloadData }) => {
    const echartRef = useRef(null);
    const [t] = useTranslation("metrics")
    const [tIncidents] = useTranslation("incidents")

    const [data, setData] = useState([]);
    const [dataFiltered, setDataFiltered] = useState([]);
    const [chartType, setChartType] = useState('createdMonth');
    const [companyNames, setCompanyNames] = useState([]);
    const [years, setYears] = useState([]);
    const [defaultDateRange, setDefaultDateRange] = useState([]);
    const [reloadKey, setReloadKey] = useState(false);
    const [indicatorFilter, setIndicatorFilter] = useState({ label: `${t("userForm.createdMonth")} `, value: "createdMonth" });
    const [rangeStartFilter, setRangeStartFilter] = useState(null);
    const [rangeEndFilter, setRangeEndFilter] = useState(null);
    const [companyFilter, setCompanyFilter] = useState(null);
    const [yearFilter, setYearFilter] = useState(null);



    const getOptionCreatedMonth = (data) => {
        return {
            title: {
                text: indicatorFilter ? indicatorFilter.label !== undefined ? indicatorFilter.label : '' : '',
                subtext: `${companyFilter ? companyFilter.label : companyNames[0]?.label !== undefined ? companyNames[0]?.label : ''} ${yearFilter ? '(' + yearFilter.label + ')' : years[0]?.label !== undefined ? '(' + years[0]?.label + ')' : ''}`,
                left: 'center'
            },
            tooltip: {
                trigger: 'axis',
                axisPointer: {
                    type: 'shadow'
                }
            },
            legend: {
                data: [`${t("data.caseNumber")}`], // Establece el nombre de la leyenda
                left: 'right' // Puedes ajustar la posición según necesites
            },
            xAxis: {
                type: 'category',
                data: data.months,
                axisLabel: {
                    interval: 0, // Muestra todas las etiquetas
                    rotate: 45   // Rota las etiquetas si es necesario para mejor legibilidad
                }
            },
            yAxis: {
                type: 'value',
                axisTick: {
                    // Crear ticks cada 5 unidades
                    interval: 4
                },
                axisLabel: {
                    // Formatear las etiquetas para que muestren números enteros
                    formatter: function (value) {
                        return value.toFixed(0);
                    }
                }
            },
            series: [
                {
                    name: `${t("data.caseNumber")}`, // Asegúrate de que el nombre de la serie coincida con el de la leyenda
                    type: 'bar',
                    data: data.cases,
                    itemStyle: {
                        color: '#007ac3'
                    },
                    label: {
                        show: true,
                        position: 'top',
                        rotate: 0, // Sin rotación
                        formatter: '{c}' // Muestra el número del dato
                    }
                }
            ]
        };
    };

    const getOptionCreatedSolved = (data) => {
        return {
            title: {
                text: indicatorFilter ? indicatorFilter.label : '',
                subtext: `${companyFilter ? companyFilter.label : companyNames[0]?.label} (${yearFilter ? yearFilter.label : years[0]?.label})`,
                left: 'center'
            },
            tooltip: {
                trigger: 'axis',
                axisPointer: {
                    type: 'shadow'
                }
            },
            legend: {
                data: [`${t("data.caseNumberCreated")}`, `${t("data.caseNumberSolved")}`],
                orient: 'vertical', // Configura la leyenda de manera vertical
                left: 'right', // Coloca la leyenda en el lado derecho del gráfico
                top: 'top', // Puedes ajustar para alinear verticalmente como prefieras
            },
            xAxis: {
                type: 'category',
                data: data.months,
                axisLabel: {
                    interval: 0, // Muestra todas las etiquetas
                    rotate: 45   // Rota las etiquetas si es necesario para mejor legibilidad
                }
            },
            yAxis: {
                type: 'value',
                axisTick: {
                    // Crear ticks cada 5 unidades
                    interval: 4
                },
                axisLabel: {
                    // Formatear las etiquetas para que muestren números enteros
                    formatter: function (value) {
                        return value.toFixed(0);
                    }
                }
            },
            series: [
                {
                    name: `${t("data.caseNumberCreated")}`,
                    type: 'bar',
                    data: data.createdCases,
                    itemStyle: {
                        color: '#007ac3'
                    },
                    label: {
                        show: true,
                        position: 'top',
                        rotate: 0,
                        formatter: '{c}'
                    }
                },
                {
                    name: `${t("data.caseNumberSolved")}`,
                    type: 'bar',
                    data: data.solvedCases,
                    itemStyle: {
                        color: '#429ed6'
                    },
                    label: {
                        show: true,
                        position: 'top',
                        rotate: 0,
                        formatter: '{c}'
                    }
                }
            ]
        };
    };

    const getOptionCreatedByCategory = (data) => {
        if (data.length === 0) {
            // Devolver configuración para mostrar "Sin datos"
            return {
                title: {
                    text: `   ${indicatorFilter ? indicatorFilter.label : ''} ${t("userForm.noData")}`,
                    subtext: `${companyFilter ? companyFilter.label : companyNames[0]?.label} (${rangeStartFilter && rangeEndFilter
                        ? `${rangeStartFilter.label} - ${rangeEndFilter.label}`
                        : rangeStartFilter
                            ? `${rangeStartFilter.label} - ${defaultDateRange[0]?.end}`
                            : rangeEndFilter
                                ? `${defaultDateRange[0]?.start} - ${rangeEndFilter.label}`
                                : `${defaultDateRange[0]?.start} - ${defaultDateRange[0]?.end}`
                        })`,
                    left: 'center'
                },
                tooltip: {
                    trigger: 'item'
                },
                legend: {
                    orient: 'horizontal',
                    bottom: 'bottom'
                },
                series: [
                    {
                        type: 'pie',
                        radius: '60%',
                        center: ['50%', '49%'],
                        data: [{ value: 0, name: `${t("userForm.noDataUpperCase")}` }], // Datos para el gráfico de pastel
                        emphasis: {
                            itemStyle: {
                                shadowBlur: 10,
                                shadowOffsetX: 0,
                                shadowColor: 'rgba(0, 0, 0, 0.5)',
                                color: '#007ac3'
                            }
                        },
                        label: {
                            normal: {
                                formatter: '{b}: {c} ({d}%)',
                                position: 'outside'
                            }
                        },
                        labelLine: {
                            normal: {
                                show: true
                            }
                        }
                    }
                ]
            };
        }



        return {
            title: {
                text: indicatorFilter ? indicatorFilter.label : '',
                subtext: `${companyFilter ? companyFilter.label : companyNames[0]?.label} (${rangeStartFilter && rangeEndFilter
                    ? `${rangeStartFilter.label} - ${rangeEndFilter.label}`
                    : rangeStartFilter
                        ? `${rangeStartFilter.label} - ${defaultDateRange[0]?.end}`
                        : rangeEndFilter
                            ? `${defaultDateRange[0]?.start} - ${rangeEndFilter.label}`
                            : `${defaultDateRange[0]?.start} - ${defaultDateRange[0]?.end}`
                    })`,
                left: 'center'
            },
            tooltip: {
                trigger: 'item'
            },
            legend: {
                orient: 'horizontal',
                bottom: 'bottom'
            },
            series: [
                {
                    type: 'pie',
                    radius: '60%',
                    center: ['50%', '49%'],
                    data: data,
                    emphasis: {
                        itemStyle: {
                            shadowBlur: 10,
                            shadowOffsetX: 0,
                            shadowColor: 'rgba(0, 0, 0, 0.5)'
                        }
                    },
                    label: {
                        normal: {
                            formatter: '{b}: {c} ({d}%)',
                            position: 'outside'
                        }
                    },
                    labelLine: {
                        normal: {
                            show: true
                        }
                    }
                }
            ]
        };
    };

    const getOptionCreatedByState = (data) => {
        if (data.length === 0) {
            // Devolver configuración para mostrar "Sin datos"
            return {
                title: {
                    text: `   ${indicatorFilter ? indicatorFilter.label : ''} ${t("userForm.noData")}`,
                    subtext: `${companyFilter ? companyFilter.label : companyNames[0]?.label} (${rangeStartFilter && rangeEndFilter
                        ? `${rangeStartFilter.label} - ${rangeEndFilter.label}`
                        : rangeStartFilter
                            ? `${rangeStartFilter.label} - ${defaultDateRange[0]?.end}`
                            : rangeEndFilter
                                ? `${defaultDateRange[0]?.start} - ${rangeEndFilter.label}`
                                : `${defaultDateRange[0]?.start} - ${defaultDateRange[0]?.end}`
                        })`,
                    left: 'center'
                },
                tooltip: {
                    trigger: 'item'
                },
                legend: {
                    orient: 'horizontal',
                    bottom: 'bottom',
                    data: [`${t("userForm.noDataUpperCase")}`] // Mostrar en la leyenda
                },
                series: [
                    {
                        type: 'pie',
                        radius: '60%',
                        center: ['50%', '49%'],
                        data: [{ value: 0, name: `${t("userForm.noDataUpperCase")}` }], // Datos para el gráfico de pastel
                        emphasis: {
                            itemStyle: {
                                shadowBlur: 10,
                                shadowOffsetX: 0,
                                shadowColor: 'rgba(0, 0, 0, 0.5)',
                                color: '#007ac3'
                            }
                        },
                        label: {
                            normal: {
                                formatter: '{b}: {c} ({d}%)',
                                position: 'outside'
                            }
                        },
                        labelLine: {
                            normal: {
                                show: true
                            }
                        }
                    }
                ]
            };
        }
        return {
            title: {
                text: indicatorFilter ? indicatorFilter.label : '',
                subtext: `${companyFilter ? companyFilter.label : companyNames[0]?.label} (${rangeStartFilter && rangeEndFilter
                    ? `${rangeStartFilter.label} - ${rangeEndFilter.label}`
                    : rangeStartFilter
                        ? `${rangeStartFilter.label} - ${defaultDateRange[0]?.end}`
                        : rangeEndFilter
                            ? `${defaultDateRange[0]?.start} - ${rangeEndFilter.label}`
                            : `${defaultDateRange[0]?.start} - ${defaultDateRange[0]?.end}`
                    })`,
                left: 'center'
            },
            tooltip: {
                trigger: 'item'
            },
            legend: {
                orient: 'horizontal',
                bottom: 'bottom',
            },
            series: [
                {
                    type: 'pie',
                    radius: '60%',
                    center: ['50%', '49%'],
                    data: data,
                    emphasis: {
                        itemStyle: {
                            shadowBlur: 10,
                            shadowOffsetX: 0,
                            shadowColor: 'rgba(0, 0, 0, 0.5)'
                        }
                    },
                    label: {
                        normal: {
                            formatter: '{b}: {c} ({d}%)',
                            position: 'outside'
                        }
                    },
                    labelLine: {
                        normal: {
                            show: true
                        }
                    }
                }
            ]
        };
    };

    const CHART = {
        'createdMonth': getOptionCreatedMonth(dataFiltered),
        'createdSolved': getOptionCreatedSolved(dataFiltered),
        'createdByCategory': getOptionCreatedByCategory(dataFiltered),
        'createdByState': getOptionCreatedByState(dataFiltered),
    }

    async function fetchData() {
        try {
            const response = await GetIncidentsStadisticsService();

            let names = []
            response.forEach((item) => {
                if (item.company && !names.some(name => name.value === item.company)) {
                    names.push({ label: item.company, value: item.company });
                }
            });

            names.unshift({
                label: `${t("userForm.all")} `,
                value: 'null',
            });

            let yearsArray = []
            response.forEach((item) => {
                let dateFormatted = formatToSpanishTimeZone(item.createdAt).split('/')[2];
                if (dateFormatted && !yearsArray.some(year => year.value === dateFormatted)) {
                    yearsArray.push({ label: dateFormatted, value: dateFormatted });
                }
            });

            // Encuentra las fechas mínima y máxima
            let minDate = new Date(Math.min(...response.map(item => new Date(item.createdAt))));
            let maxDate = new Date();

            // Formatea las fechas al formato 'dd/mm/yyyy'
            let minDateFormatted = `${minDate.getDate().toString().padStart(2, '0')}/${(minDate.getMonth() + 1).toString().padStart(2, '0')}/${minDate.getFullYear()}`;
            let maxDateFormatted = `${maxDate.getDate().toString().padStart(2, '0')}/${(maxDate.getMonth() + 1).toString().padStart(2, '0')}/${maxDate.getFullYear()}`;


            setDefaultDateRange([{ start: minDateFormatted, end: maxDateFormatted }]);
            setYears(yearsArray)
            setYearFilter(yearsArray[0])
            setCompanyNames(names)
            setCompanyFilter(names[0])
            setData(response)
            setDataFiltered(response)
        } catch (error) {
            console.error(error);
        }
    }



    function createDataCreatedMonthFiltered(data, companyName, year) {
        // Inicializa un objeto para almacenar los conteos
        const result = {
            months: [
                `${t("data.january")}`,
                `${t("data.february")}`,
                `${t("data.march")}`,
                `${t("data.april")}`,
                `${t("data.may")}`,
                `${t("data.june")}`,
                `${t("data.july")}`,
                `${t("data.august")}`,
                `${t("data.september")}`,
                `${t("data.october")}`,
                `${t("data.november")}`,
                `${t("data.december")}`
            ],
            cases: new Array(12).fill(0) // Inicializa un array de 12 elementos con 0s
        };
        // Filtra y cuenta los incidentes por mes
        data.forEach(incident => {
            // Verifica si el incidente corresponde a la compañía (si companyName no es nulo) y al año especificado
            if ((companyName.value === 'null' || incident.company === companyName.value) && new Date(incident.createdAt).getFullYear().toString() === year.value) {
                const month = new Date(incident.createdAt).getMonth(); // Obtiene el mes como un número (0-11)

                result.cases[month]++; // Incrementa el conteo para ese mes
            }
        });
        setDataFiltered(result)
    }

    function createDataCreatedSolvedFiltered(data, companyName, year) {
        const result = {
            months: [
                `${t("data.january")}`,
                `${t("data.february")}`,
                `${t("data.march")}`,
                `${t("data.april")}`,
                `${t("data.may")}`,
                `${t("data.june")}`,
                `${t("data.july")}`,
                `${t("data.august")}`,
                `${t("data.september")}`,
                `${t("data.october")}`,
                `${t("data.november")}`,
                `${t("data.december")}`
            ],
            createdCases: new Array(12).fill(0),
            solvedCases: new Array(12).fill(0)
        };

        data.forEach(incident => {
            if ((companyName.value === 'null' || incident.company === companyName.value) && new Date(incident.createdAt).getFullYear().toString() === year.value) {
                const monthIndex = new Date(incident.createdAt).getMonth();
                result.createdCases[monthIndex]++;
                if (incident.incidentStateId === 'ac41947f-2b62-45bc-a156-4774846c58a0') {
                    result.solvedCases[monthIndex]++;
                }
            }
        });

        setDataFiltered(result)
    }

    function createDataCreatedByCategoryFiltered(data, companyName, start, end) {

        // Convertir start y end a objetos Date para facilitar la comparación
        const startDate = start ? new Date(start.value) : null;
        const endDate = end ? new Date(end.value) : null;

        // Filtrar los datos
        const filteredData = data.filter(incident => {
            // Comprobar la coincidencia con la compañía
            const companyMatch = companyName.value === 'null' || incident.company === companyName.value;
            // Convertir la fecha del incidente a un objeto Date
            const incidentDate = new Date(incident.createdAt);
            // Comprobar la coincidencia con el rango de fechas, si se proporcionaron
            const dateMatch = (!startDate || incidentDate >= startDate) && (!endDate || incidentDate <= endDate);

            return companyMatch && dateMatch;
        });

        // Contar la frecuencia de cada categoría en los datos filtrados
        const categoryCounts = filteredData.reduce((acc, item) => {
            acc[item.incidentCategory] = (acc[item.incidentCategory] || 0) + 1;
            return acc;
        }, {});

        // Formatear los datos
        const formattedData = Object.entries(categoryCounts).map(([name, value]) => ({
            name,
            value
        }));

        setDataFiltered(formattedData);
    }

    function createDataCreatedByStateFiltered(data, companyName, start, end) {
        const cancelled = tIncidents("summaryCard.canceled");
        const inProgress = tIncidents("summaryCard.running");
        const pending = tIncidents("summaryCard.notAdmitted");
        const pendingResolution = tIncidents("summaryCard.waitingResolution");
        const resolved = tIncidents("summaryCard.solved");

        const stateColors = {
            [cancelled]: "#979797",
            [inProgress]: "#ffbb00",
            [pending]: "#F33527",
            [pendingResolution]: "#0071bc",
            [resolved]: "#47a44b",
        };

        const startDate = start ? new Date(start.value) : null;
        const endDate = end ? new Date(end.value) : null;

        // Filtrar los datos
        const filteredData = data.filter(incident => {
            // Comprobar la coincidencia con la compañía
            const companyMatch = companyName.value === 'null' || incident.company === companyName.value;
            // Convertir la fecha del incidente a un objeto Date
            const incidentDate = new Date(incident.createdAt);
            // Comprobar la coincidencia con el rango de fechas, si se proporcionaron
            const dateMatch = (!startDate || incidentDate >= startDate) && (!endDate || incidentDate <= endDate);

            return companyMatch && dateMatch;
        });

        // Contar la frecuencia de cada estado en los datos filtrados
        const stateCounts = filteredData.reduce((acc, item) => {
            acc[item.incidentState] = (acc[item.incidentState] || 0) + 1; // Asegúrate de que 'incidentState' es la propiedad correcta
            return acc;
        }, {});

        // Formatear los datos
        const formattedData = Object.entries(stateCounts).map(([name, value]) => (
            {
                name,
                value,
                itemStyle: {
                    color: stateColors[name.toUpperCase()] || "#000000" // Usar 'name' para obtener el color
                }
            }));

        setDataFiltered(formattedData);
    }





    const handleFieldChange = (type, label, value) => {
        let switchType = chartType;
        if (type === 'indicator') {
            switchType = value
        }
        const CREATEDATA = {
            'createdMonth': ({ company, year }) => createDataCreatedMonthFiltered(data, company, year),
            'createdSolved': ({ company, year }) => createDataCreatedSolvedFiltered(data, company, year),
            'createdByCategory': ({ company, start, end }) => createDataCreatedByCategoryFiltered(data, company, start, end),
            'createdByState': ({ company, start, end }) => createDataCreatedByStateFiltered(data, company, start, end),
        };
        switch (type) {
            case 'indicator':
                setReloadKey(!reloadKey)
                setIndicatorFilter({ label: label, value: "createdMonth" });
                setChartType(value);
                setYearFilter(years[0]);
                setRangeStartFilter(null);
                setRangeEndFilter(null);
                setCompanyFilter(companyNames[0]);
                if (CREATEDATA[switchType]) {
                    CREATEDATA[switchType]({ company: companyNames[0], year: years[0] });
                }
                break;
            case 'rangeStart':
                setRangeStartFilter({ label: label, value: value });
                if (CREATEDATA[switchType]) {
                    CREATEDATA[switchType]({ company: companyFilter, start: { label: label, value: value }, end: rangeEndFilter });
                }
                break;
            case 'rangeEnd':
                setRangeEndFilter({ label: label, value: value });
                if (CREATEDATA[switchType]) {
                    CREATEDATA[switchType]({ company: companyFilter, start: rangeStartFilter, end: { label: label, value: value } });
                }
                break;
            case 'company':
                setCompanyFilter({ label: label, value: value });
                if (CREATEDATA[switchType]) {
                    CREATEDATA[switchType]({ company: { label: label, value: value }, year: yearFilter, start: rangeStartFilter, end: rangeEndFilter });
                }
                break;
            case 'year':
                setYearFilter({ label: label, value: value });
                if (CREATEDATA[switchType]) {
                    CREATEDATA[switchType]({ company: companyFilter, year: { label: label, value: value } });
                }
                break;
            default:

        }
    };

    const handleDownload = (echartRef) => {
        let fileName = indicatorFilter.label.trim().replace(/ /g, "_");


        if (!echartRef.current) {
            return;
        }

        const imageURL = echartRef.current.getEchartsInstance().getDataURL({
            type: 'png',
            pixelRatio: 2,
            backgroundColor: '#fff'
        });

        const link = document.createElement('a');
        link.href = imageURL;
        link.download = `${fileName}_myReport!n.png`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };


    useEffect(() => {

        fetchData();

    }, []);

    useEffect(() => {

        fetchData();

    }, [reloadData]);

    useEffect(() => {

        createDataCreatedMonthFiltered(data, companyNames[0], years[0])

    }, [data]);




    return (
        <div className='metrics-container' key={reloadData}>

            <Col md={3}>

                <FormCard
                    title={t("userForm.indicator")}
                    type={"select"}
                    onChange={(e) =>
                        handleFieldChange("indicator", e.label, e.value)
                    }
                    options={[
                        { label: `${t("userForm.createdMonth")}`, value: "createdMonth" },
                        { label: `${t("userForm.createdSolved")}`, value: "createdSolved" },
                        { label: `${t("userForm.createdByCategory")}`, value: "createdByCategory" },
                        { label: `${t("userForm.createdByState")}`, value: "createdByState" },
                    ]}
                    selectedValue={{ label: `${t("userForm.createdMonth")}`, value: "createdMonth" }}
                    key={reloadData}
                    smallCard
                />

                {indicatorFilter &&
                    <>
                        {chartType === 'createdMonth' || chartType === 'createdSolved' ?
                            <>
                                <FormCard
                                    title={t("userForm.year")}
                                    type={"select"}
                                    onChange={(e) =>
                                        handleFieldChange("year", e.label, e.value)
                                    }
                                    options={years.length > 0 ? years : []}
                                    selectedValue={years.length > 0 ? { label: years[0].value, value: years[0].value } : null}
                                    smallCard
                                    key={chartType}


                                />
                            </>
                            :

                            <>
                                <FormCard
                                    title={t("userForm.rangeStart")}
                                    type={"date-range"}
                                    onChange={(e) =>
                                        handleFieldChange("rangeStart", formatFromDatePicker(e.target.value), e.target.value)
                                    }
                                    minDate
                                    maxToday
                                    smallCard
                                    key={reloadKey}
                                />

                                <FormCard
                                    title={t("userForm.rangeEnd")}
                                    type={"date-range"}
                                    onChange={(e) =>
                                        handleFieldChange("rangeEnd", formatFromDatePicker(e.target.value), e.target.value)
                                    }
                                    minDate={rangeStartFilter?.value}
                                    maxToday
                                    smallCard
                                    key={`end-${reloadKey}`}
                                />
                            </>

                        }
                        <FormCard
                            title={t("userForm.company")}
                            type={"select"}
                            onChange={(e) =>
                                handleFieldChange("company", e.label, e.value)
                            }
                            options={companyNames.length > 0 ? companyNames : []}
                            smallCard
                            key={reloadKey}
                            selectedValue={companyNames.length > 0 ? { label: companyNames[0].label, value: companyNames[0].value } : null}

                        />
                    </>
                }
                <Button onClick={() => handleDownload(echartRef)} className='custom-button-primary mt-5 mx-auto d-flex justify-content-center '>
                    <FaRegImage className='text-white' size={20} />
                    <span className='fs-9 ps-2'>{t("userForm.downloadImage")}</span>
                </Button>
            </Col>

            <Col md={8}>
                <div className={` height-110`}>


                    <ReactECharts
                        ref={echartRef}
                        key={chartType}
                        option={chartType ? CHART[chartType] : null}
                        className='height-100'
                    />


                </div>
            </Col>


        </div>
    );
};



export default CaseMetrics;
